// extracted by mini-css-extract-plugin
module.exports = {"nav__link":"styles_nav__link__3hvb4","nav__link_primary":"styles_nav__link_primary__Y67r_","nav__link_active":"styles_nav__link_active__InL65"};